import Vue from "vue";
import VueRouter from "vue-router";
import home from "../views/home.vue";
import city from "../views/city.vue";
import productFilter from "../views/productFilter.vue";
import foot2 from "../views/foot2.vue";
import foot3 from "../views/foot3.vue";
import mine from "../views/mine.vue";
import shopList from "../views/shopList.vue";
import testHome from "../views/testHome.vue";
import extension from "../views/extension.vue";

Vue.use(VueRouter);

const router = new VueRouter({
	mode: "history",
	base: "/",
	routes: [{
			path: "/",
			name: "home",
			redirect:"/home",
		},{
			path: "/home",
			name: "home",
			component: home,
			meta: {
				keepAlive: true, // 此组件需要被缓存
			}
		},{
			path: "/city",
			name: "city",
			component: city
		},{
			path: "/productFilter",
			name: "productFilter",
			component: productFilter
		},{
			path: "/foot2",
			name: "foot2",
			component: foot2
		},{
			path: "/foot3",
			name: "foot3",
			component: foot3
		},{
			path: "/shopList",
			name: "shopList",
			component: shopList
		},{
			path: "/mine",
			name: "mine",
			component: mine
		},{
			path: "/testHome",
			name: "testHome",
			component: testHome
		},{
			path: "/extension",
			name: "extension",
			component: extension
		}
	]

})
export default router;
